import {createRecipeLibraryEntry} from './library.js';

function stageTargetMap(plan){
  return new Map(plan.stageTargets.map(target=>[target.recipeStageId,target]));
}

function itemTargetMap(plan){
  const map=new Map();
  for(const target of plan.stageItemTargets){
    if(!map.has(target.recipeStageId))map.set(target.recipeStageId,[]);
    map.get(target.recipeStageId).push(target);
  }
  return map;
}

export function recipeDetailModel(plan,options={}){
  const entry=createRecipeLibraryEntry(plan,options);
  const value=entry.plan;
  const targets=stageTargetMap(value);
  const itemTargets=itemTargetMap(value);
  const itemNames=new Map(value.items.map(item=>[item.id,item.name]));
  const preparations=new Map(value.preparations.map(prep=>[prep.recipeItemId,prep]));

  return Object.freeze({
    id:entry.id,
    title:entry.title,
    description:entry.description,
    source:Object.freeze({
      type:entry.type,
      authorName:entry.authorName,
      sourceName:entry.sourceName,
      sourceUrl:entry.sourceUrl,
      version:entry.version,
      trust:entry.trust
    }),
    compatibility:entry.compatibility,
    approximateMinutes:entry.approximateMinutes,
    difficulty:entry.difficulty,
    experienceGuidance:entry.experienceGuidance,
    items:Object.freeze(value.items.map(item=>Object.freeze({
      id:item.id,
      name:item.name,
      quantity:item.referenceQuantity,
      mass:item.referenceMass,
      massUnit:item.massUnit,
      preparation:preparations.get(item.id)||null
    }))),
    woods:Object.freeze(value.woods.map(wood=>Object.freeze({
      id:wood.id,
      name:wood.name,
      sharePercent:wood.sharePercent
    }))),
    stages:Object.freeze(value.stages.map((stage,index)=>{
      const target=targets.get(stage.id)||null;
      return Object.freeze({
        id:stage.id,
        number:index+1,
        typeKey:stage.typeKey,
        name:stage.nameOverride||stage.typeKey,
        instructions:stage.instructions,
        target,
        itemTargets:Object.freeze((itemTargets.get(stage.id)||[]).map(item=>Object.freeze({
          itemId:item.recipeItemId,
          itemName:itemNames.get(item.recipeItemId)||'Produkt',
          targetInternalCelsius:item.targetInternalCelsius
        })))
      });
    })),
    safetyRules:entry.safetyRules,
    userSafetyNotes:entry.userSafetyNotes,
    tips:entry.tips,
    actions:Object.freeze({
      use:true,
      save:entry.visibility!=='private'||Boolean(entry.authorUserId),
      copy:entry.type!=='private'
    }),
    plan:value
  });
}
